import React from 'react';
import { Stack, Typography, Tooltip } from '@mui/material';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import CandidateFeedbackButton from './candidateFeedbackButton';
import { ICandidateFeedbackListDetails } from 'modules/hiring/models/candidateFeedbackListDetails.model';
import {
  FeedbackDetailResponseItemsName,
  FeedbackHiringDecision,
} from 'models/enum';
import { completeDateFormat } from 'utilities/formatDate';

export interface ICandidateFeedbackDetailHeader {
  data: ICandidateFeedbackListDetails;
  indexValue: number;
}

const buttonWidthByVariant = {
  recommends: '8.5rem',
  doesntRecommend: '12.375rem',
  notSure: 'auto',
};

const CandidateFeedbackDetailHeader = ({
  data,
  indexValue,
}: ICandidateFeedbackDetailHeader) => {
  const interviewerName = data?.interviewerDetails?.interviewerName;

  return (
    <Stack
      id={`feedback-detail-header-${indexValue}`}
      data-testid={`feedback-detail-header-${indexValue}`}
      direction='row'
      justifyContent='space-between'
      sx={{ display: 'flex', flexWrap: 'wrap' }}
    >
      <Stack>
        <Tooltip title={interviewerName || ''} arrow placement='top'>
          <div>
            <TypographyWithI18N
              className='kfic2-bodyTextBold'
              id={`interviewer-name-${indexValue}`}
              data-testid={`interviewer-name-${indexValue}`}
              i18nKey='feedbackFromSome'
              options={{ arg1: interviewerName }}
              style={{
                width: '100%',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                cursor: 'pointer',
                wordBreak: 'break-word',
              }}
            />
          </div>
        </Tooltip>
        <Stack direction='row'>
          <TypographyWithI18N
            className='kfic2-bodyTextSmall'
            i18nKey='feedbackGivenOn'
            textSuffix=':'
          />
          <Typography
            sx={{
              fontWeight: '700',
              pl: '0.313rem',
            }}
            className='kfic2-bodyTextSmall'
            id={`interview-date-${indexValue}`}
            data-testid={`interview-date-${indexValue}`}
          >
            {completeDateFormat(data?.response?.responseSubmitted)}
          </Typography>
        </Stack>
      </Stack>
      {data?.response?.responseItemList.map((finalData, index) => {
        const variant =
          finalData?.selectedOption === FeedbackHiringDecision.RECOMMENDS
            ? 'recommends'
            : finalData?.selectedOption ===
              FeedbackHiringDecision.DOESNTRECOMMEND
            ? 'doesntRecommend'
            : 'notSure';
        if (finalData?.name === FeedbackDetailResponseItemsName.RECOMMENDHIRE)
          return (
            <CandidateFeedbackButton
              key={index}
              id={`decision-option-${index}`}
              data-testid={`decision-option-${index}`}
              buttonSx={{
                cursor: 'default !important',
                padding: '0.25rem 0.5rem 0.25rem 0.75rem',
                height: '2rem !important',
                borderRadius: '1rem !important',
                width: buttonWidthByVariant[variant],
                margin: '3px 10px 3px 0px',
              }}
              variant={variant}
            />
          );
      })}
    </Stack>
  );
};

export default CandidateFeedbackDetailHeader;
